__turbopack_context__.v({
  "box": "first-loader-module__va0YYa__box",
  "loader": "first-loader-module__va0YYa__loader",
  "loader-box": "first-loader-module__va0YYa__loader-box",
});
